import { Injectable } from '@angular/core';
import * as Enums from './../../../../Autofacets-Core/src/app/utils/enums';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor() { // This is intentional
  }

  validateImageFormat(mimeType:string) : boolean
  {
    if(mimeType === Enums.MimeType.PNG ||mimeType === Enums.MimeType.JPEG ||mimeType === Enums.MimeType.JPG
    || mimeType === Enums.MimeType.GIF  || mimeType === Enums.MimeType.SVG || mimeType === '' || mimeType === null)
    {
        return true;
    }
    return false;
  }
}
